import React, { FC } from 'react';
import { Box, Container, Grid, Skeleton, useTheme } from '@mui/material';

const MembershipPlansSectionSkeleton: FC = () => {
     const theme = useTheme();
  return (

    <Box py={8}  sx={{
                  bgcolor: theme.palette.grey[800]
                }}>
      <Container maxWidth="xl">
        <Box textAlign="center" mb={6}>
          <Skeleton variant="text" width={300} height={50} sx={{ mx: 'auto' }} />
          <Skeleton variant="text" width={250} height={30} sx={{ mx: 'auto', mt: 2 }} />
        </Box>

        <Grid container spacing={4}>
           {[...Array(3).keys()].map((item) => (
            <Grid item sm={12} md={6} lg={4} key={item}>
              <Box
                p={3}
            
              >
                <Skeleton variant="text" width={100} height={30} />
                <Skeleton variant="text" width={120} height={50} sx={{ my: 2 }} />
                <Skeleton variant="text" width="60%" height={20} />

                <Box mt={2}>
                   {[...Array(3).keys()].map((item) => (
                    <Skeleton key={item} variant="text" width="90%" height={20} sx={{ mb: 1 }} />
                  ))}
                </Box>

                <Skeleton variant="rectangular" width="100%" height={45} sx={{ mt: 3, borderRadius: 2 }} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>

  );
};

export { MembershipPlansSectionSkeleton };